export default __webpack_public_path__ + "static/race-day-toddler-trot-vertical-13b53ca369da44b8da12cb620b9462a5.png";